/**
 * Draft Storage Service
 * 
 * CRUD operations for visit form drafts and media files in IndexedDB
 */
import type { VisitFormDraft } from '@ox/ox-brokerage-client';
import { db, type StoredDraft } from '@ox/visits-ui/db/visitFormsDB';

// ============================================================================
// DRAFT OPERATIONS
// ============================================================================

/**
 * Save or update draft in IndexedDB
 * Uses VisitFormDraft interface directly
 */
export async function saveDraft(draft: VisitFormDraft): Promise<void> {
  const existing = await db.drafts.where('id').equals(draft.id).first();
  
  const storedDraft: StoredDraft = {
    ...draft,
    updatedAt: new Date(), // Update timestamp
  };

  if (existing) {
    // Update existing draft
    await db.drafts.put({
      ...storedDraft,
      _id: existing._id, // Preserve auto-increment ID
    });
  } else {
    // Add new draft
    await db.drafts.add(storedDraft);
  }
}

/**
 * Get draft from IndexedDB by draft ID
 */
export async function getDraft(draftId: string): Promise<VisitFormDraft | null> {
  const draft = await db.drafts.where('id').equals(draftId).first();
  return draft || null;
}

/**
 * Clear draft and all associated media from IndexedDB
 */
export async function clearDraft(draftId: string): Promise<void> {
  await db.drafts.where('id').equals(draftId).delete();
}
